import { render } from "./SelectGenero.vue?vue&type=template&id=36dc86a2"
import script from "./SelectGenero.vue?vue&type=script&lang=js"
export * from "./SelectGenero.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__